import isEmpty from 'lodash/isEmpty'
import formatPercent from '@/modules/_helpers/formatPercent'
import { isNaN } from 'lodash'

const EMPTY_PROP = '–'

export const getCustomerKind = (kind) => {
  switch (kind) {
    case 'person':
      return 'Privat'
    case 'company':
      return 'Firma'
    default:
      return 'Privat'
  }
}

export default class CustomerListModel {
  constructor(data) {
    this.id = data.id || undefined
    this.number = data.number || EMPTY_PROP
    this.kind = data.kind
    this.category = data.category || EMPTY_PROP
    this.firstName = data.firstName || EMPTY_PROP
    this.lastName = data.lastName || EMPTY_PROP
    this.name = data.name || EMPTY_PROP
    this.mainContact = data.mainContact || EMPTY_PROP
    if (!isEmpty(data.address)) {
      this.street = data.address.street || EMPTY_PROP
      this.zipCode = data.address.zipCode || EMPTY_PROP
      this.city = data.address.city || EMPTY_PROP
    }
    this.phone = data.phone || EMPTY_PROP
    this.email = data.email || EMPTY_PROP
    this.balance = isNaN(data.balance) ? EMPTY_PROP : data.balance
    this.discount = formatPercent(data.discount) || EMPTY_PROP
    this.totalSales = data.totalSales
    this.countryIso = data.countryIso || EMPTY_PROP
    this.tags = data.tags || []
    this.menu = ''
  }
}
